import { SlotGenerationResult } from '../core/availabilities';
import { HttpClient } from './http';

export interface AvailabilitySlotsService {
  computeSlotsForCustomerDay: (params: {
    providerId: string;
    appointmentTypeId: string;
    customerDateISO?: string;
    customerTz: string;
    // Makes the response grandfathered for that reschedule. The server resolves
    // the anchor from the code; an unknown code falls back to the plain window.
    rescheduleCode?: string;
  }) => Promise<SlotGenerationResult>;
}

export function createAvailabilitySlotsService(
  httpClient: HttpClient,
  baseUrl: string,
): AvailabilitySlotsService {
  return {
    computeSlotsForCustomerDay: (params) => {
      return httpClient<SlotGenerationResult>(
        `${baseUrl}/availability-slots/compute-slots-for-customer-day`,
        'get',
        {
          query: params,
        },
      );
    },
  };
}
